import React from "react";
import { Col } from "react-bootstrap";

export default function ErrorProcessingRequest() {
  return (
    <Col className="error left-side d-flex align-items-center justify-content-center">
      <div className="text-center">
        <p>Oops! <br />There was an error processing your request. <br />Please try again later.</p>
      </div>
    </Col>
  )
}


// WEBPACK FOOTER //
// ./src/components/Helpers/Errors/Templates/ErrorProcessingRequest.js